import { useEffect, useState } from 'react';
import { Layout } from '@/components/layout/Layout';
import { motion } from 'framer-motion';
import { ExternalLink, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Status() {
  const [isLoading, setIsLoading] = useState(true);
  const statusPageUrl = 'https://nexqr1.statuspage.io/';

  useEffect(() => {
    // Preload the iframe
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-6"
        >
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold flex items-center gap-3">
                <img src="/logo.png" alt="NexQR" className="h-10 w-auto" />
                System Status
              </h1>
              <p className="text-muted-foreground mt-1">
                Real-time service health and incident updates
              </p>
            </div>
            <Button
              variant="outline"
              onClick={() => window.open(statusPageUrl, '_blank')}
            >
              <ExternalLink className="h-4 w-4 mr-2" />
              Open in New Tab
            </Button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="relative bg-background border border-border rounded-xl overflow-hidden shadow-lg"
          style={{ height: 'calc(100vh - 250px)', minHeight: '600px' }}
        >
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-10">
              <div className="text-center">
                <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-4" />
                <p className="text-muted-foreground">Loading status page...</p>
              </div>
            </div>
          )}
          
          <iframe
            src={statusPageUrl}
            title="NexQR System Status"
            className="w-full h-full border-0"
            onLoad={() => setIsLoading(false)}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </motion.div>
      </div>
    </Layout>
  );
}
